import { message } from 'antd'
import { MerchantSetting } from 'hooks/useGlobalQuery'

export const crmUrl = (merchantSetting: MerchantSetting) => {
  if (merchantSetting?.integration_settings?.crm?.enabled) {
    return 'https://app.crm.slerp.com/#/login'
  } else {
    return 'https://www.slerp.com/crm-book-a-demo/'
  }
}

export const getLocationNameFromPath = (
  slug: string | undefined,
  isAvailabilityRules: RegExpMatchArray | null,
  location: Location
) => {
  if (!slug) return message.error('No partner slug found')

  const merchantSlug = slug
  const matchLocationSlug =
    location?.pathname?.match(/\/location\/(.*?)\/availability-rules/) ?? []
  const locationSlug =
    isAvailabilityRules && matchLocationSlug ? matchLocationSlug[1] : ''

  const locationName = locationSlug
    .replace(`${merchantSlug}-`, '')
    .replace(/-/g, ' ')

  return locationName
}

export const isAvailabilityRulesForm = (location: Location) =>
  location?.pathname?.includes('/availability-rules/') &&
  (location.pathname.split('/rule/')[1]?.length > 0 ||
    location?.pathname?.endsWith('/create'))

export const isAvailabilityRules = (location: Location) =>
  location?.pathname?.match(/\/availability-rules(?:\/|$)/)
